/**
 *
 * Asynchronously loads the component for AccessControlPermissions
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () {
        return import(/* webpackChunkName: 'AccessControlPermissions' */ './index');
    },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
